var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor suppression-remove" }, [
    _c(
      "div",
      { staticClass: "editor-row" },
      [
        _c("div", { staticClass: "editor-row-title" }, [_vm._v("Type")]),
        _vm._v(" "),
        _c("a-select", {
          staticClass: "classic-new-select",
          attrs: { placeholder: "Ban Type", options: _vm.types },
          model: {
            value: _vm.clone.type,
            callback: function ($$v) {
              _vm.$set(_vm.clone, "type", $$v)
            },
            expression: "clone.type",
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _vm.clone.type && _vm.clone.type !== "web-visitor"
      ? _c(
          "div",
          { staticClass: "editor-row" },
          [
            _c("div", { staticClass: "editor-row-title" }, [_vm._v("Value")]),
            _vm._v(" "),
            _c("TiptapEditor", {
              attrs: {
                placeholder: "Value",
                "show-attributes": true,
                "max-character-count": 500,
              },
              model: {
                value: _vm.clone.value,
                callback: function ($$v) {
                  _vm.$set(_vm.clone, "value", $$v)
                },
                expression: "clone.value",
              },
            }),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }